import { render, staticRenderFns } from "./OperaCouponListWindow.vue?vue&type=template&id=b952c562&scoped=true"
import script from "./OperaCouponListWindow.vue?vue&type=script&lang=js"
export * from "./OperaCouponListWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaCouponListWindow.vue?vue&type=style&index=0&id=b952c562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b952c562",
  null
  
)

export default component.exports